import { handleActions } from 'redux-actions';
import {
  fetchConnectionInfo,
  fetchRoles,
  updateConnectionInfo,
  updateRoles,
  connectionSuccess,
  disconnectSuccess,
} from './actions';
import { reduxKey } from './constants';
import { DiscordState } from './types';

const handler = handleActions<DiscordState, any>(
  {
    [fetchConnectionInfo.toString()]: state => ({
      ...state,
      connection: { ...state.connection, isLoading: true, isReady: false },
    }),
    [updateConnectionInfo.toString()]: (
      state,
      { payload }: ReturnType<typeof updateConnectionInfo>
    ) => ({
      ...state,
      connection: { ...payload, isLoading: false, isReady: true },
    }),
    [connectionSuccess.toString()]: (
      state,
      { payload }: ReturnType<typeof connectionSuccess>
    ) => ({
      ...state,
      connection: {
        ...state.connection,
        connected: true,
        connectedJustNow: payload.justNow,
      },
    }),
    [disconnectSuccess.toString()]: (
      state,
      { payload }: ReturnType<typeof disconnectSuccess>
    ) => ({
      ...state,
      connection: { isReady: false },
      roles: { isReady: false },
    }),
    [fetchRoles.toString()]: state => ({
      ...state,
      roles: { ...state.roles, isLoading: true, isReady: false },
    }),
    [updateRoles.toString()]: (
      state,
      { payload: { roles } }: ReturnType<typeof updateRoles>
    ) => ({
      ...state,
      roles: { roles, isLoading: false, isReady: true },
    }),
  },
  {
    isReduxInitialized: false,
    connection: { isReady: false },
    roles: { isReady: false },
  }
);

export default {
  [reduxKey as string]: handler,
};
